import { AfterViewInit,SimpleChanges,Component,ViewEncapsulation, OnInit, OnDestroy ,Input, Output, DoCheck} from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
declare var $:any;
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {NgbdModalContent} from '../../dashboard/modals/calender_create_newsletter/modal1.component';

import {NgbdModalBasic} from '../../dashboard/modals/calender_invite_modal/invite_modal.component';

import * as moment from 'moment';
import {CommonService} from '../../services/common.service';



@Component({
  selector: 'month-view-cal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './month_view_cal.component.html',
  
})
export class MonthViewCompnent implements OnInit,DoCheck,AfterViewInit{


    @Input() month:number;
    @Input() month_with_years:string;
    @Input() year:number;
    @Input() newsletters:any;
    @Input() permissions;
    @Input() user;

    current_newsletters:any;
    current_newsletter_index:number;
    commonService:any;


    disable_open:boolean =true;


    closeResult: string;

 
    constructor(private _coS:CommonService,private modalService: NgbModal ,private msg:MessageService ,private _router:Router) {


        // let current_newsletters=  this.newsletters.filter( (item) => { return item.month==this.month && item.year==this.year; } );
     
    this.commonService= _coS;    
  

    }

    ngOnInit(): void {


       
       if( parseInt(moment().format('MM')) > this.month && parseInt(moment().format('YYYY')) >= this.year){
          
        this.disable_open =false;

       }

   

     

 
       
        this.current_newsletters=  this.newsletters.filter( (item) => { return item.month==this.month && item.year==this.year; } );
       
        
 
    } 

    
    ngAfterViewInit():void{

      $(function(){

       $('body').tooltip({
         selector: '.tooltip-custom'
     });


      });


   }

    ngDoCheck(): void {
        //Called every time that the input properties of a component or a directive are checked. Use it to extend change detection by performing a custom check.
        //Add 'implements DoCheck' to the class.

    
       

        this.current_newsletters=  this.newsletters.filter( (item) => { return item.month==this.month && item.year==this.year; } );

        
    }

  openInvite(index:number){


    const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup new_invite_popup"});

    modalRef1.componentInstance.month = this.month;
 
    modalRef1.componentInstance.year = this.year;
 
    modalRef1.componentInstance.newsletterI = this.current_newsletters[0].newsletters[index];
    

    modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {

    modalRef1.close();

    this.msg.sendMessage({'type':'event_calander_update','records':{ 
      'month':this.month,
      'year':this.year,                 
      'newsletter':{
                      index:index,
                      id:receivedEntry.id,
                      name: receivedEntry.name,
                      publish:receivedEntry.publish,
                      deadline:receivedEntry.deadline,
                      number:receivedEntry.number,
                      description:receivedEntry.description,
                      invite:receivedEntry.invite
                   
                   }
      
       }});

      });

  }


   edit (i:number) {

 
    
    const modalRef = this.modalService.open(NgbdModalContent,{ windowClass : "addnew-popup"});

    modalRef.componentInstance.month = this.month;
 
    modalRef.componentInstance.year = this.year;

    modalRef.componentInstance.newsletterI = this.current_newsletters[0].newsletters[i];
 
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {

     
     modalRef.close();

         
       this.msg.sendMessage({'type':'event_calander_update','records':{ 
                 'month':this.month,
                 'year':this.year,                 
                 'newsletter':{
                                 index:i,
                                 id:receivedEntry.id,
                                 name: receivedEntry.name,
                                 publish:receivedEntry.publish,
                                 deadline:receivedEntry.deadline,
                                 number:receivedEntry.number,
                                 description:receivedEntry.description,
                                 invite:receivedEntry.invite
                              
                              }
                 
                  }});

 


     })


   }
    
    open( ) {

               //,{ windowClass : "invite"}

              

               const modalRef = this.modalService.open(NgbdModalContent,{ windowClass : "addnew-popup"});
               

               modalRef.componentInstance.month = this.month;
            
               modalRef.componentInstance.year = this.year;
            
               modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {

                
                modalRef.close();
                    
                  this.msg.sendMessage({'type':'event_calander_add','records':{ 
                            'month':this.month,
                            'year':this.year,                 
                            'newsletter':{
                                            name: receivedEntry.name,
                                            publish:receivedEntry.publish,
                                            deadline:receivedEntry.deadline,
                                            number:receivedEntry.number,
                                            description:'',
                                            invite:[]

                                         }
                            
                             }});

            


                })




    }

    navigate(id){
      let link= '/newsletter/'+id+'/edit'
      this._router.navigate([link]);
    }

   
    

}